import { useState } from 'react';
import { Modal } from '../modal';
import { Button } from '../button';
import { TextField } from '../text-field';
import { Select } from '../select';
import { useSelected } from '../../providers/selectedContext';
import { addUserToProject } from '../../api/data';
import { Project } from '../../@types/projects/types';

export interface AddMemberModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (project: Project) => void;
}

const ROLE_OPTIONS = [
  { value: 'reader', label: 'Reader' },
  { value: 'writer', label: 'Writer' },
];

const formStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

const footerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
};

const AddMemberModal = ({ open, onClose, onSuccess }: AddMemberModalProps) => {
  const { selectedInfo } = useSelected();
  const [email,   setEmail]   = useState('');
  const [role,    setRole]    = useState('reader');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setEmail('');
    setRole('reader');
    onClose();
  };

  const handleSave = async () => {
    const project = selectedInfo.project;
    if (!project || !email.trim()) return;
    setLoading(true);
    try {
      const response = await addUserToProject(email.trim(), project.uid, role);
      onSuccess(response);
      handleClose();
    } catch (error) {
      console.error('ERROR WHILE ADDING MEMBER:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Invite Member"
      size="sm"
      footer={
        <div style={footerStyle}>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave} loading={loading} disabled={!email.trim()}>
            Invite Member
          </Button>
        </div>
      }
    >
      <div style={formStyle}>
        <TextField
          label="Email"
          type="email"
          fullWidth
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="colleague@example.com"
        />
        <Select
          label="Role"
          fullWidth
          options={ROLE_OPTIONS}
          value={role}
          onChange={val => setRole(val)}
        />
      </div>
    </Modal>
  );
};

export { AddMemberModal };
